import React, { useState } from 'react';
import { Fab, Tooltip, Badge, Zoom } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import CloseIcon from '@mui/icons-material/Close';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import EnhancedChatWindow from './EnhancedChatWindow';

interface FloatingChatBubbleProps {
  newMessages?: number;
}

const FloatingChatBubble: React.FC<FloatingChatBubbleProps> = ({ newMessages = 0 }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  const toggleChat = () => {
    setIsChatOpen(!isChatOpen);
  };

  return (
    <>
      {/* Chat Window */}
      <Zoom in={isChatOpen}>
        <div style={{ 
          position: 'fixed', 
          bottom: '80px', 
          right: '20px', 
          zIndex: 1000,
          width: '400px',
          height: '600px',
          maxWidth: '90vw',
          maxHeight: '80vh',
          boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
          borderRadius: '16px',
          overflow: 'hidden'
        }}>
          <EnhancedChatWindow onClose={() => setIsChatOpen(false)} />
        </div>
      </Zoom>

      {/* Floating Button */}
      <Tooltip title={isChatOpen ? "Close chat" : "Open chat assistant"} placement="left">
        <Fab 
          color="primary" 
          aria-label="chat"
          onClick={toggleChat}
          style={{ 
            position: 'fixed', 
            bottom: '20px', 
            right: '20px',
            zIndex: 1001
          }}
        >
          <Badge badgeContent={!isChatOpen ? newMessages : 0} color="error">
            {isChatOpen ? <CloseIcon /> : <SmartToyIcon />}
          </Badge>
        </Fab>
      </Tooltip>
    </>
  );
};

export default FloatingChatBubble; 